import Icon from 'components/_UI/Icon';
import Loader from 'components/_UI/Loader';
import React from 'react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

export default function EstablishmentServicesOptions({ data, content, fullWidth, loading }) {
    const isServiceSelected = (service) => {
        return data.some(el => el.id === service.id);
    };

    if (loading) {
        return (
            <FullyCentered>
                <Loader />
            </FullyCentered>
        );
    }

    return (
        <Container>
            <SectionTitle>Opções de serviços</SectionTitle>

            <ServicesGrid fullWidth={fullWidth}>
                {
                    content.map((service) => {
                        const selected = isServiceSelected(service);
                        return (
                            <ServiceChip key={service.id} selected={selected}>
                                <IconWrapper selected={selected}>
                                    <Icon
                                        name={selected ? 'check' : 'close'}
                                        color={selected ? colors.successDark : colors.nightLight}
                                    />
                                </IconWrapper>
                                <ServiceLabel selected={selected}>
                                    {service.name}
                                </ServiceLabel>
                            </ServiceChip>
                        );
                    })
                }
            </ServicesGrid>
        </Container>
    );
}

const Container = styled(Column)`
    width: 100%;
    gap: 8px;
`;

const SectionTitle = styled.p`
    font-size: ${fonts.sizes.small};
    font-weight: ${fonts.weight.bold};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${colors.night};
    text-align: center;
    margin-bottom: 4px;
`;

const ServicesGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;

    ${({ fullWidth }) => fullWidth && `
        @media screen and (min-width: ${breakpoints.md}) {
            grid-template-columns: 1fr 1fr 1fr;
        }
    `};
`;

const ServiceChip = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 10px;
    transition: background 0.15s ease;

    ${({ selected }) => selected
        ? `background: rgba(39, 183, 93, 0.06);`
        : `background: rgba(0, 0, 0, 0.02);`
    }
`;

const IconWrapper = styled.div`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    ${({ selected }) => selected
        ? `background: rgba(39, 183, 93, 0.12);`
        : `background: rgba(0, 0, 0, 0.04);`
    }
`;

const ServiceLabel = styled.span`
    font-size: ${fonts.sizes.small};
    line-height: 1.3;

    ${({ selected }) => selected
        ? `color: ${colors.nightDark};`
        : `color: ${colors.nightLight};`
    }
`;
